import OldVersionAlert from './OldVersionAlert';

export default OldVersionAlert;
